<script setup lang="ts">
import RuleEngineBuilder from "@/modules/rule_engine/pages/RuleEngineBuilder.vue";
</script>

<template>
	<!--
		The PQA model has no per_hour rule set, so the builder is pointed at per_proposal.
		Breadcrumbs are suppressed because the PQA module shell (Index.vue) already renders
		them together with the module tabs. Navigation stays on the PQA routes: PQA users need
		not have access to the rule engine module.
	-->
	<rule-engine-builder
		default-version-type="per_proposal"
		:show-breadcrumbs="false"
		:route-names="{
			builder: 'pqa.rules.builder',
			versions: 'pqa.rules.versions',
			overview: 'pqa.rules',
		}"
	/>
</template>

<style scoped lang="scss"></style>
